import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = '024424835f51cfaa90fa700a3939355b';

export const initAnalytics = () => {
  mixpanel.init(MIXPANEL_TOKEN, {
    track_pageview: false,
    persistence: 'localStorage',
    record_sessions_percent: 100,
  });
};

export const trackEvent = (name: string, properties?: Record<string, unknown>) => {
  try {
    mixpanel.track(name, properties);
  } catch {
    // Silently fail if Mixpanel isn't initialized
  }
};

export const identifyUser = (userId: string, email: string, displayName: string) => {
  try {
    mixpanel.identify(userId);
    mixpanel.people.set({
      $email: email,
      $name: displayName,
      last_login: new Date().toISOString(),
    });
  } catch {
    // Silently fail
  }
};

export const resetUser = () => {
  try {
    mixpanel.reset();
  } catch {
    // Silently fail
  }
};
